export default __webpack_public_path__ + "static/media/116.655bc7bc.jpg";